import {IProfileAddress} from '../../../../../../../services/hookService/getOrderDetails/types';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';

interface IProps {
  buyerName: string;
  buyerState: string;
  profileAddress: IProfileAddress | null;
  buyerCity: string;
  buyerNumber: string;
  isOrderCompleted: boolean;
}

const MyStoreBuyerInformation = ({
  buyerName,
  profileAddress,
  buyerState,
  buyerCity,
  buyerNumber,
  isOrderCompleted,
}: Partial<IProps>) => {
  const formattedAddress = `${
    buyerState && buyerCity ? buyerState + ' / ' + buyerCity : ''
  } ${
    profileAddress?.delivery_address
      ? ',' + profileAddress?.delivery_address
      : ''
  } ${
    profileAddress?.building_number
      ? ', پلاک ' + profileAddress?.building_number
      : ''
  }`;

  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-zinc-500">اطلاعات خریدار</span>

      <div className="p-3 space-y-2 bg-zinc-100 rounded-xl">
        <InfoRow
          icon="icon-nameProfile"
          label="نام و نام خانوادگی"
          value={buyerName ?? profileAddress?.name ?? 'مشخص نشده'}
        />
        {(profileAddress?.delivery_address ||
          buyerCity ||
          buyerState ||
          profileAddress?.building_number) && (
          <InfoRow
            icon="icon-nameLocation"
            label="آدرس گیرنده"
            value={formattedAddress}
          />
        )}
        {profileAddress?.postal_code && (
          <InfoRow
            icon="icon-nameemail-sendng"
            label="کد پستی"
            value={profileAddress?.postal_code}
          />
        )}
        {isOrderCompleted ? (
          <InfoRow
            icon="icon-namecall"
            label="شماره تماس"
            value={buyerNumber}
          />
        ) : (
          <a href={`tel:${buyerNumber}`} className="block no-underline">
            <InfoRow
              icon="icon-namecall"
              className="text-lime-700"
              labelClassName="text-lime-700"
              label="شماره تماس"
              value={buyerNumber}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default MyStoreBuyerInformation;
